export default __webpack_public_path__ + "static/media/announcement-warning.368a86dc.svg";